<template>
  <div>
    <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
      <AwardIcon />
      <h2 class="text-lg font-medium mr-auto">{{ $t('advertisement.list') }}</h2>
      <div class="w-full sm:w-auto flex mt-4 sm:mt-0">
        <router-link :to="{ name: 'superadmin-tools-advertisement-add' }">
          <button class="btn btn-primary shadow-md mr-2">
            {{ $t('advertisement.add') }}
          </button>
        </router-link>
      </div>
    </div>
    <!-- BEGIN: HTML Table Data -->
    <div class="intro-y box p-5 mt-5">
      <AdvertisementListTable />
    </div>
    <!-- END: HTML Table Data -->
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import AdvertisementListTable from '@/components/advertisement/AdvertisementListTable'

export default defineComponent({
  components: {
    AdvertisementListTable
  },
  setup() {
    return {}
  }
})
</script>
